import { GET_MITARBEITER_PERSONAL_IDS } from '@/domain/mitarbeiter/features/anlageassistent/hooks/useMitarbeiterPersonalIds/graphql/queries';
import {
  Mitarbeiter_GetMitarbeiterPersonalIdsQuery,
  Mitarbeiter_GetMitarbeiterPersonalIdsQueryVariables,
} from '@/gql/graphql';
import * as Sentry from '@sentry/react';
import { useSuspenseQuery } from '@apollo/client/react';

export function useMitarbeiterPersonalIds(standortId: string): {
  e2nIds: string[];
  personalnummern: string[];
} {
  const { data, error } = useSuspenseQuery<
    Mitarbeiter_GetMitarbeiterPersonalIdsQuery,
    Mitarbeiter_GetMitarbeiterPersonalIdsQueryVariables
  >(GET_MITARBEITER_PERSONAL_IDS, {
    variables: {
      standortId,
    },
  });

  if (error) {
    Sentry.captureException(error);
    return { e2nIds: [], personalnummern: [] };
  }

  return {
    e2nIds: data.Anlageassistent_getMitarbeiterPersonalIds.e2nIdMitarbeiter
      .filter((m) => m.e2nId)
      .map((m) => m.e2nId ?? ''),
    personalnummern:
      data.Anlageassistent_getMitarbeiterPersonalIds.personalnummernMitarbeiter.map(
        (m) => m.personalnummer,
      ),
  };
}
